var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlaggedcontent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6294 2.37534V4.84982H17.4012V17.0157H28.9358L24.4798 9.69537L28.9358 2.375L14.6294 2.37534Z",
    fill: "#978284"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25195 4.84984C4.92345 4.36222 5.36269 3.57297 5.36269 2.68148C5.36269 1.20299 4.15998 0 2.68121 0C1.20271 0 0 1.20299 0 2.68148C0 3.7508 0.630839 4.6731 1.53829 5.10358L1.53856 36H3.82439L3.82413 22.432V21.0255H15.9948L15.9951 6.25622H3.82371V5.10296C3.97465 5.03201 4.11761 4.94698 4.25154 4.84999L4.25195 4.84984Z",
    fill: "#978284"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaggedcontent);
export default __webpack_public_path__ + "static/media/flaggedcontent.ca9fa462a783f5ffcb1070a5615101c9.svg";
export { ForwardRef as ReactComponent };